import React from 'react'
import { Link } from 'react-router-dom'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import { withRouter } from 'react-router'
import L from '../L'
import IconMenu from '../../Icons/IconMenu'
import { StyledMenu, StyledMenuItem } from '../NavMenu'
import StyledMenuIcon from './Tabs-styles'

const CustomTabs = ({ tabs, fullWidth, onChange, shadow, tab, dark, ...props }) => {
  let tabIndex = props.tabIndex || 0
  if (tabs[0].link) {
    for (let i = 0; i < tabs.length; i++) {
      if (tab === tabs[i].link) tabIndex = i
    }
  }

  return (
    <Tabs
      value={tabIndex}
      indicatorColor="primary"
      className={[fullWidth ? 'full-width' : '', shadow ? 'shadow' : '', dark ? 'dark' : ''].join(' ')}
      onChange={(e, newIndex) => {
        if (onChange && !tabs[newIndex].onClick) onChange(newIndex)
      }}
    >
      {tabs.map((tab, idx) => (
        <Tab
          key={`tab_${idx}`}
          className={[dark ? 'dark' : ''].join(' ')}
          onMouseUp={() => {
            if (tab.onClick) tab.onClick()
          }}
          label={
            tab.link ? (
              <Link to={tab.link} style={{ color: 'inherit' }}>
                <L display="grid" flow="column" ai="center" gap={1}>
                  {tab.icon ? tab.icon : null}
                  <div>{tab.label}</div>
                </L>
              </Link>
            ) : (
              <L display="grid" flow="column" ai="center" gap={1}>
                {tab.icon ? tab.icon : null}
                <div>{tab.label}</div>
              </L>
            )
          }
        />
      ))}
    </Tabs>
  )
}

const MobileTabs = props => {
  // eslint-disable-next-line no-unused-vars
  let index = props.index || 0
  if (props.tabs[0].link) {
    for (let i = 0; i < props.tabs.length; i++) {
      if (props.tab === props.tabs[i].link) index = i
    }
  }
  const [isOpen, setIsOpen] = React.useState(false)
  const [anchorEl, setAnchorEl] = React.useState(null)
  const dropdownWidth = 0

  const handleClick = event => {
    if (window.innerWidth < 1024) {
      document.getElementById('tab-menu').style.width = `100%`
      document.getElementById('tab-menu').style.marginLeft = `-15px`
    } else {
      document.getElementById('tab-menu').style.width = `${Math.max(event.currentTarget.offsetWidth, 175)}px`
      document.getElementById('tab-menu').style.marginLeft = `0px`
    }
    !isOpen ? setAnchorEl(event.currentTarget) : setAnchorEl(null)
    setIsOpen(!isOpen)
  }

  const handleClose = () => {
    setAnchorEl(null)
    setIsOpen(false)
  }

  return (
    <div>
      <StyledMenuIcon active={isOpen} onClick={handleClick}>
        <IconMenu color={isOpen ? '#E11C8E' : '#033691'} />
      </StyledMenuIcon>
      <StyledMenu
        id="tab-menu"
        className="menu--add-shadow"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        style={{ width: `${dropdownWidth}px` }}
      >
        <L pT={1.5} pB={1}>
          {props.tabs.map((tab, idx) => (
            <Link key={`tab-menu_${idx}`} to={tab.link}>
              <StyledMenuItem
                className={['menu-item--secondary', props.location.pathname === tab.link ? 'active' : ''].join(' ')}
              >
                {tab.label}
              </StyledMenuItem>
            </Link>
          ))}
        </L>
      </StyledMenu>
    </div>
  )
}

export const HamburgerTabs = withRouter(MobileTabs)

export default CustomTabs
